import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		stroke: "#595959",
		strokeWidth: 1.5,
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12.74.75a10.47 10.47 0 0 0-9.17 5.387 10.492 10.492 0 0 0 .26 10.638L.75 23.25l6.468-3.084a10.484 10.484 0 0 0 13.29-1.838A10.503 10.503 0 0 0 12.74.75Z",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15 15.75h-.75a1.5 1.5 0 0 1-1.5-1.5V10.5a.75.75 0 0 0-.75-.75h-.75",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M12.375 6.75a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75" })
		]
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%0A%20%20%20%20%3Cg%20stroke%3D%22%23595959%22%20stroke-width%3D%221.5%22%20clip-path%3D%22url(%23a)%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%0A%20%20%20%20%20%20%20%20%20%20%20%20d%3D%22M12.74.75a10.47%2010.47%200%200%200-9.17%205.387%2010.492%2010.492%200%200%200%20.26%2010.638L.75%2023.25l6.468-3.084a10.484%2010.484%200%200%200%2013.29-1.838A10.503%2010.503%200%200%200%2012.74.75Z%22%0A%20%20%20%20%20%20%20%20%20%20%20%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15%2015.75h-.75a1.5%201.5%200%200%201-1.5-1.5V10.5a.75.75%200%200%200-.75-.75h-.75%22%20stroke-linecap%3D%22round%22%0A%20%20%20%20%20%20%20%20%20%20%20%20stroke-linejoin%3D%22round%22%20%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12.375%206.75a.375.375%200%200%201%200-.75m0%20.75a.375.375%200%200%200%200-.75%22%20%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E";
